import type {CrmCredentials, NetworkLib, NetworkResponse} from "@fd/Types.ts";


function crmEndpoint(crm:CrmCredentials, ep:string):string {
	let url = crm.url;
	let path = ep;
	if (!path.startsWith("/")) path = "/" + path;
	if (!url) {
		// endpoint is relative to the current server root
		return path;
	} else {
		// url must not end with slash
		if (url.endsWith("/")) url = url.substring(0, url.length - 1);
		return url + path;
	}
}


export function contact(crm: CrmCredentials, endpoint: string, method: string, body: any = null, accept: string = "application/json"): Promise<Response> {
    const headers: HeadersInit = {
        Accept: accept,
    };
	const useCredentials = crm.login && crm.password;
	if (useCredentials) {
		headers["Authorization"] = "Basic " + btoa(crm.login + ":" + crm.password);
	}

    const ops: RequestInit = {
        method: method,
        mode: "cors",
        cache: "no-cache",
        credentials: useCredentials ? "omit" : "same-origin",
        headers: headers,
        redirect: "follow",
        referrerPolicy: "no-referrer",
    };
    if (body) {
		if (body instanceof FormData) {
			ops.body = body;
			/* fetch set content type itself */
			delete headers["Content-Type"];
		} else {
			ops.body = typeof body === "string" ? body : JSON.stringify(body);
			headers["Content-Type"] = "application/json";
		}
    }
	const crmep = crmEndpoint(crm, endpoint);
	console.log(ops.method + " " + crmep + " credentials=" + ops.credentials);
	return fetch(crmep, ops);
}

export type QueryParamType = string | number | boolean;

export function urlParam(url: string, name: string, value: QueryParamType|QueryParamType[]): string {
	if (Array.isArray(value)) {
		for (let val of value) {
			url = urlParam(url, name, val);
		}
		return url;
	}
	const separ = url.indexOf("?") >= 0 ? "&" : "?";
	let res = url + separ + name;
	if (value != null && !(typeof value === "undefined")) {
		res = res + "=";
		switch (typeof value) {
			case "string":
				res = res + encodeURIComponent(value);
				break;
			case "number":
				res = res + value;
				break;
			case "boolean":
				res = res + (value ? "true" : "false");
				break;
		}
	}
	return res;
}

export function buildNetLib(crm:CrmCredentials):NetworkLib {

	const netlib: NetworkLib = {
		urlParam: urlParam,

		fetch: function (endpoint: string, method: string = "GET", body?: any, accept?: string): Promise<NetworkResponse> {
			// if (endpoint.startsWith('/')) {
			// 	// Endpoint is specified as absolute path. It must be prefixed with context path to support CRM not running in the root
			// 	endpoint = window.Server.context + endpoint;
			// }

			return contact(crm, endpoint, method, body, accept)
				.then((response) => {
					let nr: NetworkResponse = {
						status: response.status,
						ok: response.ok,
						json: () => response.json(),
						text: () => response.text()
					};
					return nr;
				});
		}
	};
	return netlib;
}
